var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTreasury(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.7815 10.7891C24.6926 10.7891 25.0729 9.61852 24.3328 9.07893L13.0722 0.887758C12.9114 0.769939 12.7172 0.706421 12.5179 0.706421C12.3185 0.706421 12.1243 0.769939 11.9635 0.887758L0.702883 9.07893C-0.0372111 9.61557 0.343156 10.7891 1.25722 10.7891H3.08239V21.8168H0.95941C0.829672 21.8168 0.723523 21.923 0.723523 22.0527V24.4705C0.723523 24.6003 0.829672 24.7064 0.95941 24.7064H24.0763C24.206 24.7064 24.3122 24.6003 24.3122 24.4705V22.0527C24.3122 21.923 24.206 21.8168 24.0763 21.8168H21.9533V10.7891H23.7815ZM8.65522 21.8168H5.20537V10.7891H8.65522V21.8168ZM14.228 21.8168H10.7782V10.7891H14.228V21.8168ZM19.8303 21.8168H16.351V10.7891H19.8303V21.8168Z",
    fill: "#DDDDDD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreasury);
export default __webpack_public_path__ + "static/media/treasury.0016cc33.svg";
export { ForwardRef as ReactComponent };